package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.data.network.response.SendPushRequest
import com.clany.backoffice.data.network.response.SendPushResponse
import com.clany.backoffice.data.network.response.SendEmailRequest
import com.clany.backoffice.data.network.response.PreviewTargetRequest
import com.clany.backoffice.data.network.response.PreviewTargetResponse
import com.clany.backoffice.domain.repository.NotificationRepository
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import io.ktor.http.HttpMethod

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
class NotificationRepositoryImpl @Inject constructor(
    private val networkClient: NetworkClient
) : NotificationRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun sendNotification(request: SendPushRequest): Result<SendPushResponse> {
        return networkClient.request<SendPushResponse>(
            "$baseUrl/api/notifications/send",
            HttpMethod.Post,
            request
        )
    }

    override suspend fun sendEmail(request: SendEmailRequest): Result<SendPushResponse> {
        return networkClient.request<SendPushResponse>(
            "$baseUrl/api/notifications/email",
            HttpMethod.Post,
            request
        )
    }

    override suspend fun previewTarget(request: PreviewTargetRequest): Result<PreviewTargetResponse> {
        return networkClient.request<PreviewTargetResponse>(
            "$baseUrl/api/notifications/preview",
            HttpMethod.Post,
            request
        )
    }
}
